import { Component, OnDestroy, OnInit } from '@angular/core';
import { hits, configure, pagination } from 'instantsearch.js/es/widgets';
import { InstantSearchService } from './shared/services/instant-search.service';
import connectSearchBox, { SearchBoxConnectorParams } from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import { filter, map, Subscription, take } from 'rxjs';
import { Hit, InstantSearch, UiState, Widget } from 'instantsearch.js';
import { AlgoliaRecordHit } from './shared/models/algolia-record-hit';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits';
import connectInfiniteHits from 'instantsearch.js/es/connectors/infinite-hits/connectInfiniteHits';

@Component({
    selector: 'app-global-search',
    templateUrl: './global-search.component.html',
    styleUrl: './global-search.component.scss',
    standalone: false
})
export class GlobalSearchComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();
  widgets: Widget[] = [];
  hits: Hit[] = [];
  connectHits: AlgoliaRecordHit[] = [];


  constructor(
    private instantSearchService: InstantSearchService
  ) { }


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

  }

}
